//#region src/dom/hotkey/aria.ts
const ARIA_MODIFIER_MAP = {
	shift: "Shift",
	ctrl: "Control",
	alt: "Alt",
	meta: "Meta"
};
const DISPLAY_MODIFIER_MAP = {
	shift: "Shift",
	ctrl: "Ctrl",
	alt: "Alt",
	meta: "Meta"
};
const MODIFIER_ORDER = [
	"ctrl",
	"shift",
	"alt",
	"meta"
];
/**
* Convert parsed key bindings to a WAI-ARIA `aria-keyshortcuts` formatted string.
*
* @example
*   ```ts
*   toAriaKeyShortcut(parseHotkeyPattern('Ctrl+Shift+f'));
*   // "Control+Shift+f"
*
*   toAriaKeyShortcut([...parseHotkeyPattern('k'), ...parseHotkeyPattern('Space')]);
*   // "k Space"
*   ```;
*/
function toAriaKeyShortcut(bindings) {
	return bindings.map((b) => {
		const parts = [];
		for (const mod of MODIFIER_ORDER) if (b.modifiers.has(mod)) parts.push(ARIA_MODIFIER_MAP[mod]);
		parts.push(b.originalKey);
		return parts.join("+");
	}).join(" ");
}
/** Convert a parsed key binding to a compact display shortcut. */
function toDisplayKeyShortcut(binding) {
	const parts = [];
	for (const mod of MODIFIER_ORDER) if (binding.modifiers.has(mod)) parts.push(DISPLAY_MODIFIER_MAP[mod]);
	parts.push(toDisplayKey(binding.originalKey));
	return parts.join("+");
}
function toDisplayKey(key) {
	return key.length === 1 ? key.toUpperCase() : key;
}
//#endregion
export { toAriaKeyShortcut, toDisplayKeyShortcut };

//# sourceMappingURL=aria.js.map